// frontend/src/config.ts
const config = {
  ENVIRONMENT: import.meta.env.VITE_ENVIRONMENT || "development",
  AUTH_MODE: (import.meta.env.VITE_AUTH_MODE === "iap" ? "iap" : "pkce") as
    | "pkce"
    | "iap",
  BACKEND_URL: import.meta.env.VITE_BACKEND_URL,
  REDIRECT_URI: import.meta.env.VITE_REDIRECT_URI,
  ATHENA_CLIENT_ID: import.meta.env.VITE_ATHENA_CLIENT_ID,
  ENCRYPTION_KEY: import.meta.env.VITE_ENCRYPTION_KEY, // Included as it's used in apiUtils
};

// Basic validation example (can be expanded)
if (!config.ATHENA_CLIENT_ID) {
  // eslint-disable-next-line no-console
  console.warn("Warning: VITE_ATHENA_CLIENT_ID is not set.");
}
if (!config.REDIRECT_URI) {
  // eslint-disable-next-line no-console
  console.warn("Warning: VITE_REDIRECT_URI is not set.");
}
if (!config.BACKEND_URL) {
  // eslint-disable-next-line no-console
  console.warn("Warning: VITE_BACKEND_URL is not set.");
}
// No warning for ENCRYPTION_KEY as apiUtils already logs a warning if it's not set and body exists.

export default config;
